module.exports = __webpack_public_path__ + "static/media/delete.5e47ae12.svg";